












































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  KitDinamico,
  KitsDinamicosService,
} from "@/services/kits-dinamicos.service";
import { required, validDate } from "@/shared/validators";
import { moeda } from "@/shared/filters";
import InputMoeda from "@/shared/components/input-moeda.vue";
import DatePicker from "@/shared/components/date-picker.vue";

@Component({
  components: { InputMoeda, DatePicker },
  filters: { moeda },
})
export default class KitDinamicoForm extends Vue {
  @Prop() kitdinamico!: KitDinamico;

  valid = false;
  title = "";
  loading = false;
  snackbar = false;
  text = "";

  rules = {
    descricao: [required()],
    codigoFornecedor: [required()],
    validoApos: [required(), validDate()],
    validoAte: [validDate()],
  };

  async salvarKitDinamico() {
    const form = this.$refs.form as any;

    if (form.validate()) {
      if (this.kitdinamico) {
        if (this.validaItens()) {
          this.loading = true;
          try {
            const res = await KitsDinamicosService.manterKitDinamico(
              this.kitdinamico
            );
            this.$emit("saved", res);
          } finally {
            this.loading = false;
            this.text = "Kit dinânimco salvo!";
            this.snackbar = true;
          }
        }
      }
    }
  }

  validaItens(): boolean {
    if (!this.kitdinamico.excluido) {
      if (this.kitdinamico.items!.length == 0) {
        this.text = "Não pode ativar o kit dinâmico sem itens!";
        this.snackbar = true;
        return false;
      }
    }
    return true;
  }

  voltar() {
    this.$router.back();
  }
}
